import { render, staticRenderFns } from "./ConsultResponseDetail.vue?vue&type=template&id=421cdfc6&scoped=true&"
import script from "./ConsultResponseDetail.vue?vue&type=script&lang=ts&"
export * from "./ConsultResponseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultResponseDetail.vue?vue&type=style&index=0&id=421cdfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421cdfc6",
  null
  
)

export default component.exports